export const ASSET_CARD_SIZE = "80px";

export const SUBSCRIPTION_PRICE_QUERY_KEY = "subscription-prices";
